import { useAppSelector } from '@/shared/lib/redux'
import { useMemo } from 'react'
import { selectRegistrationStatistics } from '../../model'
import { ChartData, ChartOptions } from 'chart.js'
import { ChartBlock } from '@/shared/ui/chart-block'
import {ru} from 'date-fns/locale'

export const RegistrationStatistics = () => {
    const registrationStatistics = useAppSelector(selectRegistrationStatistics)
    
    const data: ChartData<"line"> = useMemo(() => {
        const labels: string[] = []
        const data: number[] = []
        Object.entries(registrationStatistics)
            .sort(([a], [b]) => new Date(b).getTime() - new Date(a).getTime())
            .forEach(([k,v]) => {
                labels.push(k)
                data.push(Number(v))
            })
        return {
            labels,
            datasets: [{
                label: 'Новых пользователей',
                fill: true,
                borderColor: 'rgba(5, 205, 153, 0.8)',
                borderWidth: 2,
                backgroundColor: function(ctx) {
                    const gradient = ctx.chart.ctx.createLinearGradient(0, 0, 0, 400);
                    gradient.addColorStop(0.01, 'rgb(5, 205, 153,0.6)');
                    gradient.addColorStop(0.7, 'rgb(5, 205, 153,0.1)');
                    return gradient
                },
                cubicInterpolationMode: 'monotone',
                data
            }]
        }
    }, [registrationStatistics])
    
    const options: ChartOptions<"line"> = {
        scales: {
            y: {
                ticks: {
                    maxTicksLimit: 10
                },
                border: {
                    dash: [8, 4],
                    color: 'rgba(0, 0, 0, 0)'
                },
            },
            x: {
                type: 'time', 
                time: {
                    unit: 'week',
                    round: 'day',
                    tooltipFormat: 'LLL d, yyyy'
                },
                adapters: {
                    date: {
                        locale: ru
                    }
                },
                grid: {
                    drawOnChartArea: false
                },
                border: {
                    color: 'rgba(0, 0, 0, 0)'
                }
            },
        },
    }

    return (
        <ChartBlock options={options} type="line" chartClass="min-h-[350px] screen:min-h-[335px]" title="Динамика регистрации пользователей" data={data} />
    )
}